import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.map.js";
import _objectWithoutProperties from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { APIErrorResponse, UIError } from "./errors";
import { CommonTypes } from "./types";
import { handle, ERRORS } from "@dp/common";
import moment from "moment-timezone";
var CONTENTTYPE = "application/json";

var Payment = /*#__PURE__*/function () {
  function Payment(config, axios) {
    _classCallCheck(this, Payment);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(Payment, [{
    key: "getOrdersSessionToken",
    value: function () {
      var _getOrdersSessionToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var agentID,
            correlationID,
            retryCount,
            _yield$handle,
            _yield$handle2,
            err,
            response,
            respData,
            status,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                agentID = _args.length > 0 && _args[0] !== undefined ? _args[0] : "native";
                correlationID = _args.length > 1 && _args[1] !== undefined ? _args[1] : "";
                retryCount = _args.length > 2 && _args[2] !== undefined ? _args[2] : 0;
                _context.next = 5;
                return handle(this.axios.post(this.config.postfix.SESSION_TOKEN, {
                  agentID: agentID,
                  correlationID: correlationID
                }));

              case 5:
                _yield$handle = _context.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                err = _yield$handle2[0];
                response = _yield$handle2[1];
                respData = response === null || response === void 0 ? void 0 : response.data;
                status = respData === null || respData === void 0 ? void 0 : respData.status;

                if (!(!err && status === "SUCCESS")) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return", {
                  correlationID: respData.correlationID,
                  customerID: respData.customerID,
                  sessionToken: respData.sessionToken
                });

              case 15:
                return _context.abrupt("return", this.handleOrderSessionTokenError(response, err, retryCount, agentID, correlationID));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getOrdersSessionToken() {
        return _getOrdersSessionToken.apply(this, arguments);
      }

      return getOrdersSessionToken;
    }()
  }, {
    key: "handleOrderSessionTokenError",
    value: function handleOrderSessionTokenError(response, err, retryCount, agentID, correlationID) {
      var respData = response === null || response === void 0 ? void 0 : response.data;
      var status = respData === null || respData === void 0 ? void 0 : respData.status;
      var responseCode = respData === null || respData === void 0 ? void 0 : respData.responseCode;

      if (responseCode === "sessionTokenLimitExceeded") {
        throw new APIErrorResponse({
          config: response.config,
          request: response.request,
          response: response
        });
      } else {
        if (retryCount > 0) {
          var newRetry = retryCount - 1;
          return this.getOrdersSessionToken(agentID, correlationID, newRetry);
        } else {
          if (err) {
            throw err;
          } else if (status !== "SUCCESS") {
            throw new APIErrorResponse({
              config: response.config,
              request: response.request,
              response: response
            });
          } else {
            return response.data;
          }
        }
      }
    }
  }, {
    key: "getRSAToken",
    value: function () {
      var _getRSAToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload, jwtToken) {
        var _this = this;

        var retryCount, apiPayload, headers;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                retryCount = payload.retryCount, apiPayload = _objectWithoutProperties(payload, ["retryCount"]);

                if (!(retryCount <= 0)) {
                  _context2.next = 3;
                  break;
                }

                throw ERRORS.ERROR_SESSION_TOKEN_FAILURE;

              case 3:
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                return _context2.abrupt("return", this.axios.post(this.config.postfix.RSA_TOKEN, apiPayload, {
                  headers: headers
                }).then(function (response) {
                  var rsaResponseData = response.data.response;
                  var status = rsaResponseData.status;

                  if (status === "ACTIVE") {
                    var _rsaResponseData$corr;

                    return {
                      rsaData: _objectSpread(_objectSpread({}, rsaResponseData), {}, {
                        correlationId: (_rsaResponseData$corr = rsaResponseData.correlationId) !== null && _rsaResponseData$corr !== void 0 ? _rsaResponseData$corr : payload.paymentCorrelationId
                      }),
                      retryRemaining: retryCount - 1
                    };
                  } else {
                    var responseCode = rsaResponseData.responseCode;

                    if (responseCode === "rsaTokenLimitExceeded") {
                      throw new Error("Status: " + 400);
                    } else {
                      if (retryCount > 0) {
                        var newRetry = retryCount - 1;
                        return _this.getRSAToken(_objectSpread(_objectSpread({}, payload), {}, {
                          retryCount: newRetry
                        }), jwtToken);
                      } else {
                        var _rsaResponseData$corr2;

                        return {
                          rsaData: _objectSpread(_objectSpread({}, rsaResponseData), {}, {
                            correlationId: (_rsaResponseData$corr2 = rsaResponseData.correlationId) !== null && _rsaResponseData$corr2 !== void 0 ? _rsaResponseData$corr2 : payload.paymentCorrelationId
                          }),
                          retryRemaining: retryCount - 1
                        };
                      }
                    }
                  }
                })["catch"](function (error) {
                  throw new UIError(error);
                }));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getRSAToken(_x, _x2) {
        return _getRSAToken.apply(this, arguments);
      }

      return getRSAToken;
    }()
  }, {
    key: "validateToken",
    value: function () {
      var _validateToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload, jwtToken) {
        var _this2 = this;

        var commonQueryParams, locale, headers;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                return _context3.abrupt("return", this.axios.post(this.config.postfix.VALIDATE_TOKEN, payload, {
                  params: {
                    locale: locale
                  },
                  headers: headers
                }).then(function (response) {
                  var _response$data;

                  var respData = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.response;
                  var status = respData === null || respData === void 0 ? void 0 : respData.transStatus;

                  if (status === "Success") {
                    return;
                  } else {
                    // Error handling
                    var code = respData === null || respData === void 0 ? void 0 : respData.statusCode;
                    var message = respData === null || respData === void 0 ? void 0 : respData.statusMessage;
                    var responseCode = respData === null || respData === void 0 ? void 0 : respData.responseCode;

                    if (responseCode === "validateTokenLimitExceeded") {
                      throw new Error("Status: " + 400);
                    } else if (status === "error") {
                      var isBusinessFault = _this2.isBusinessFault({
                        code: code,
                        message: message
                      });

                      if (isBusinessFault) {
                        throw ERRORS.CVV_VALIDATION_ERROR;
                      } else {
                        throw new Error("Status: " + 400);
                      }
                    } else {
                      throw new Error("Status: " + 500);
                    }
                  }
                })["catch"](function (error) {
                  throw new UIError(error);
                }));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function validateToken(_x3, _x4) {
        return _validateToken.apply(this, arguments);
      }

      return validateToken;
    }()
  }, {
    key: "getApplePaySessionToken",
    value: function () {
      var _getApplePaySessionToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var jwtToken,
            trackingId,
            transactionType,
            initiativeContext,
            headers,
            _yield$handle3,
            _yield$handle4,
            err,
            response,
            _response$data2,
            _args4 = arguments;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                jwtToken = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : null;
                trackingId = _args4.length > 1 ? _args4[1] : undefined;
                transactionType = _args4.length > 2 ? _args4[2] : undefined;
                initiativeContext = _args4.length > 3 ? _args4[3] : undefined;
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                _context4.next = 8;
                return handle(this.axios.post(this.config.postfix.GET_APPLE_PAY_TOKEN, {
                  trackingId: trackingId,
                  transactionType: transactionType,
                  initiativeContext: initiativeContext
                }, {
                  headers: headers
                }));

              case 8:
                _yield$handle3 = _context4.sent;
                _yield$handle4 = _slicedToArray(_yield$handle3, 2);
                err = _yield$handle4[0];
                response = _yield$handle4[1];

                if (!err) {
                  _context4.next = 16;
                  break;
                }

                throw err;

              case 16:
                return _context4.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.response);

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getApplePaySessionToken() {
        return _getApplePaySessionToken.apply(this, arguments);
      }

      return getApplePaySessionToken;
    }()
  }, {
    key: "getPaymentToken",
    value: function () {
      var _getPaymentToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(sessionToken, payload) {
        var retryCount,
            corsPrefixURL,
            commonProps,
            origin,
            headers,
            _yield$handle5,
            _yield$handle6,
            err,
            response,
            _reqError$response,
            reqError,
            responseData,
            isBusinessFault,
            newRetry,
            respData,
            code,
            message,
            _isBusinessFault,
            _newRetry,
            _args5 = arguments;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                retryCount = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : 0;
                corsPrefixURL = this.config.getPrefix().CORS_DOMAIN;
                commonProps = this.config.getCommonProps();
                origin = commonProps.origin;
                headers = {
                  "Content-Type": CONTENTTYPE,
                  "X-App-UserId": sessionToken.customerID,
                  "X-Merchant-Id": this.config.getGiftCardType(),
                  "X-Message-Sending-PartnerId": "DARDEN_MOBILE",
                  "X-Request-ID": sessionToken.correlationID,
                  "X-User-SessionToken": sessionToken.sessionToken
                };

                if (origin) {
                  headers["Origin"] = origin;
                }

                _context5.next = 8;
                return handle(this.axios.post(corsPrefixURL + this.config.postfix.CORS_URL, payload, {
                  headers: headers,
                  params: _objectSpread(_objectSpread({}, this.config.getCommonQueryParams()), {}, {
                    noTag: true
                  })
                }));

              case 8:
                _yield$handle5 = _context5.sent;
                _yield$handle6 = _slicedToArray(_yield$handle5, 2);
                err = _yield$handle6[0];
                response = _yield$handle6[1];

                if (!err) {
                  _context5.next = 28;
                  break;
                }

                reqError = err;
                responseData = reqError === null || reqError === void 0 ? void 0 : (_reqError$response = reqError.response) === null || _reqError$response === void 0 ? void 0 : _reqError$response.data;
                isBusinessFault = this.isBusinessFault(responseData);

                if (!isBusinessFault) {
                  _context5.next = 20;
                  break;
                }

                throw err;

              case 20:
                if (!(retryCount > 0)) {
                  _context5.next = 25;
                  break;
                }

                newRetry = retryCount - 1;
                return _context5.abrupt("return", this.getPaymentToken(sessionToken, payload, newRetry));

              case 25:
                throw err;

              case 26:
                _context5.next = 46;
                break;

              case 28:
                respData = response.data;
                code = respData === null || respData === void 0 ? void 0 : respData.code;
                message = respData === null || respData === void 0 ? void 0 : respData.message;

                if (!(!respData || code || message)) {
                  _context5.next = 45;
                  break;
                }

                _isBusinessFault = this.isBusinessFault({
                  code: code,
                  message: message
                });

                if (!_isBusinessFault) {
                  _context5.next = 37;
                  break;
                }

                throw respData;

              case 37:
                if (!(retryCount > 0)) {
                  _context5.next = 42;
                  break;
                }

                _newRetry = retryCount - 1;
                return _context5.abrupt("return", this.getPaymentToken(sessionToken, payload, _newRetry));

              case 42:
                return _context5.abrupt("return", respData);

              case 43:
                _context5.next = 46;
                break;

              case 45:
                return _context5.abrupt("return", respData);

              case 46:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getPaymentToken(_x5, _x6) {
        return _getPaymentToken.apply(this, arguments);
      }

      return getPaymentToken;
    }()
  }, {
    key: "getPaymentTokenRSA",
    value: function () {
      var _getPaymentTokenRSA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(rsaToken, payload) {
        var response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                response = this.makeCORSRequest(rsaToken, payload);
                _context6.next = 3;
                return response;

              case 3:
                _context6.t0 = _context6.sent.paymentToken;
                _context6.next = 6;
                return response;

              case 6:
                _context6.t1 = _context6.sent.providerToken;
                _context6.next = 9;
                return response;

              case 9:
                _context6.t2 = _context6.sent.cardType;
                return _context6.abrupt("return", {
                  paymentToken: _context6.t0,
                  provider: _context6.t1,
                  cardType: _context6.t2
                });

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getPaymentTokenRSA(_x7, _x8) {
        return _getPaymentTokenRSA.apply(this, arguments);
      }

      return getPaymentTokenRSA;
    }()
  }, {
    key: "getPayPalTokenRSA",
    value: function () {
      var _getPayPalTokenRSA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(rsaToken, payload) {
        var response;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                response = this.makePayPalCORSRequest(rsaToken, payload);
                _context7.next = 3;
                return response;

              case 3:
                _context7.t0 = _context7.sent.expiryMonth;
                _context7.next = 6;
                return response;

              case 6:
                _context7.t1 = _context7.sent.expiryYear;
                _context7.next = 9;
                return response;

              case 9:
                _context7.t2 = _context7.sent.tokenId;
                _context7.next = 12;
                return response;

              case 12:
                _context7.t3 = _context7.sent.alias;
                return _context7.abrupt("return", {
                  authStatus: "success",
                  expiryMonth: _context7.t0,
                  fdAuthorizationId: "",
                  sHostExtraInfo: "",
                  expiryYear: _context7.t1,
                  paypalToken: _context7.t2,
                  alias: _context7.t3
                });

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getPayPalTokenRSA(_x9, _x10) {
        return _getPayPalTokenRSA.apply(this, arguments);
      }

      return getPayPalTokenRSA;
    }()
  }, {
    key: "getPaymentNonceRSA",
    value: function () {
      var _getPaymentNonceRSA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(rsaToken, payload) {
        var response;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                response = this.makeCORSRequest(rsaToken, payload);
                _context8.next = 3;
                return response;

              case 3:
                _context8.t0 = _context8.sent.paymentNonce;
                _context8.next = 6;
                return response;

              case 6:
                _context8.t1 = _context8.sent.providerNonce;
                return _context8.abrupt("return", {
                  paymentNonce: _context8.t0,
                  provider: _context8.t1
                });

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getPaymentNonceRSA(_x11, _x12) {
        return _getPaymentNonceRSA.apply(this, arguments);
      }

      return getPaymentNonceRSA;
    }()
  }, {
    key: "makeCORSRequest",
    value: function () {
      var _makeCORSRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(rsaToken, payload) {
        var _respData$credit, _respData$credit$toke, _respData$credit2, _respData$credit2$tok, _respData$credit3, _respData$token, _respData$token2;

        var response, respData;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.corsRequest(rsaToken, payload);

              case 2:
                response = _context9.sent;
                respData = response === null || response === void 0 ? void 0 : response.data;
                return _context9.abrupt("return", {
                  paymentToken: respData === null || respData === void 0 ? void 0 : (_respData$credit = respData.credit) === null || _respData$credit === void 0 ? void 0 : (_respData$credit$toke = _respData$credit.token) === null || _respData$credit$toke === void 0 ? void 0 : _respData$credit$toke.tokenId,
                  providerToken: respData === null || respData === void 0 ? void 0 : (_respData$credit2 = respData.credit) === null || _respData$credit2 === void 0 ? void 0 : (_respData$credit2$tok = _respData$credit2.token) === null || _respData$credit2$tok === void 0 ? void 0 : _respData$credit2$tok.tokenProvider,
                  cardType: respData === null || respData === void 0 ? void 0 : (_respData$credit3 = respData.credit) === null || _respData$credit3 === void 0 ? void 0 : _respData$credit3.cardType,
                  paymentNonce: respData === null || respData === void 0 ? void 0 : (_respData$token = respData.token) === null || _respData$token === void 0 ? void 0 : _respData$token.tokenId,
                  providerNonce: respData === null || respData === void 0 ? void 0 : (_respData$token2 = respData.token) === null || _respData$token2 === void 0 ? void 0 : _respData$token2.tokenProvider
                });

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function makeCORSRequest(_x13, _x14) {
        return _makeCORSRequest.apply(this, arguments);
      }

      return makeCORSRequest;
    }()
  }, {
    key: "makePayPalCORSRequest",
    value: function () {
      var _makePayPalCORSRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(rsaToken, payload) {
        var _respData$paypal, _respData$paypal$cred, _respData$paypal2, _respData$paypal2$cre, _respData$paypal3, _respData$paypal3$cre, _respData$paypal3$cre2, _respData$paypal4, _respData$paypal4$cre, _respData$paypal4$cre2, _respData$paypal5, _respData$paypal5$cre, _respData$paypal5$cre2, _respData$paypal6, _respData$paypal6$cre, _respData$paypal6$cre2;

        var response, respData;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.corsRequest(rsaToken, payload);

              case 2:
                response = _context10.sent;
                respData = response.data;
                return _context10.abrupt("return", {
                  type: respData === null || respData === void 0 ? void 0 : respData.type,
                  alias: respData === null || respData === void 0 ? void 0 : (_respData$paypal = respData.paypal) === null || _respData$paypal === void 0 ? void 0 : (_respData$paypal$cred = _respData$paypal.credit) === null || _respData$paypal$cred === void 0 ? void 0 : _respData$paypal$cred.alias,
                  cardType: respData === null || respData === void 0 ? void 0 : (_respData$paypal2 = respData.paypal) === null || _respData$paypal2 === void 0 ? void 0 : (_respData$paypal2$cre = _respData$paypal2.credit) === null || _respData$paypal2$cre === void 0 ? void 0 : _respData$paypal2$cre.cardType,
                  expiryMonth: respData === null || respData === void 0 ? void 0 : (_respData$paypal3 = respData.paypal) === null || _respData$paypal3 === void 0 ? void 0 : (_respData$paypal3$cre = _respData$paypal3.credit) === null || _respData$paypal3$cre === void 0 ? void 0 : (_respData$paypal3$cre2 = _respData$paypal3$cre.expiryDate) === null || _respData$paypal3$cre2 === void 0 ? void 0 : _respData$paypal3$cre2.month,
                  expiryYear: respData === null || respData === void 0 ? void 0 : (_respData$paypal4 = respData.paypal) === null || _respData$paypal4 === void 0 ? void 0 : (_respData$paypal4$cre = _respData$paypal4.credit) === null || _respData$paypal4$cre === void 0 ? void 0 : (_respData$paypal4$cre2 = _respData$paypal4$cre.expiryDate) === null || _respData$paypal4$cre2 === void 0 ? void 0 : _respData$paypal4$cre2.year,
                  tokenProvider: respData === null || respData === void 0 ? void 0 : (_respData$paypal5 = respData.paypal) === null || _respData$paypal5 === void 0 ? void 0 : (_respData$paypal5$cre = _respData$paypal5.credit) === null || _respData$paypal5$cre === void 0 ? void 0 : (_respData$paypal5$cre2 = _respData$paypal5$cre.token) === null || _respData$paypal5$cre2 === void 0 ? void 0 : _respData$paypal5$cre2.tokenProvider,
                  tokenId: respData === null || respData === void 0 ? void 0 : (_respData$paypal6 = respData.paypal) === null || _respData$paypal6 === void 0 ? void 0 : (_respData$paypal6$cre = _respData$paypal6.credit) === null || _respData$paypal6$cre === void 0 ? void 0 : (_respData$paypal6$cre2 = _respData$paypal6$cre.token) === null || _respData$paypal6$cre2 === void 0 ? void 0 : _respData$paypal6$cre2.tokenId
                });

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function makePayPalCORSRequest(_x15, _x16) {
        return _makePayPalCORSRequest.apply(this, arguments);
      }

      return makePayPalCORSRequest;
    }()
  }, {
    key: "corsRequest",
    value: function () {
      var _corsRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(rsaToken, payload) {
        var headers, _yield$handle7, _yield$handle8, error, response, respData;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                headers = {
                  "Content-Type": CONTENTTYPE,
                  Authorization: "Bearer " + rsaToken.tokenId,
                  "Api-Key": rsaToken.apiKey,
                  Timestamp: moment().toDate().getTime(),
                  "Client-Request-Id": rsaToken.correlationId,
                  Origin: this.config.getDefaultAPIPrefix()
                };
                _context11.next = 3;
                return handle(this.axios.post(this.config.getPrefix().CORS_DOMAIN_RSA + this.config.postfix.CORS_URL_RSA, payload, {
                  headers: headers,
                  params: _objectSpread(_objectSpread({}, this.config.getCommonQueryParams()), {}, {
                    noTag: true
                  })
                }));

              case 3:
                _yield$handle7 = _context11.sent;
                _yield$handle8 = _slicedToArray(_yield$handle7, 2);
                error = _yield$handle8[0];
                response = _yield$handle8[1];
                respData = response === null || response === void 0 ? void 0 : response.data;

                if (!(error || !respData)) {
                  _context11.next = 10;
                  break;
                }

                throw error;

              case 10:
                return _context11.abrupt("return", response);

              case 11:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function corsRequest(_x17, _x18) {
        return _corsRequest.apply(this, arguments);
      }

      return corsRequest;
    }()
  }, {
    key: "isBusinessFault",
    value: function isBusinessFault(responseData) {
      var businessFaults = ["CARD_VALIDATION_FAILED", "CARD_TYPE_NOT_SUPPORTED"];

      if (responseData) {
        return businessFaults.reduce(function (res, fault) {
          if (res) {
            return true;
          } else {
            res = fault === responseData.message;
          }

          return res;
        }, false);
      } else {
        return true;
      }
    }
  }, {
    key: "tokenizeCreditCard",
    value: function () {
      var _tokenizeCreditCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(cardAccount) {
        var tokenType,
            retryCount,
            sessionToken,
            payload,
            _args12 = arguments;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                tokenType = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : "LONGTERM";
                retryCount = _args12.length > 2 && _args12[2] !== undefined ? _args12[2] : 0;
                _context12.next = 4;
                return this.getOrdersSessionToken("native", "", retryCount);

              case 4:
                sessionToken = _context12.sent;
                payload = {
                  account: cardAccount,
                  paymentTokenType: tokenType
                };
                return _context12.abrupt("return", this.getPaymentToken(sessionToken, payload, retryCount));

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function tokenizeCreditCard(_x19) {
        return _tokenizeCreditCard.apply(this, arguments);
      }

      return tokenizeCreditCard;
    }()
  }, {
    key: "logCCTokenizationFailure",
    value: function () {
      var _logCCTokenizationFailure = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(payload, jwtToken) {
        var headers, response;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                _context13.next = 5;
                return this.axios.post(this.config.postfix.TOKENIZATION_FAILURE, payload, {
                  headers: headers
                });

              case 5:
                response = _context13.sent;
                return _context13.abrupt("return", response.data);

              case 9:
                _context13.prev = 9;
                _context13.t0 = _context13["catch"](0);
                throw new UIError(_context13.t0);

              case 12:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 9]]);
      }));

      function logCCTokenizationFailure(_x20, _x21) {
        return _logCCTokenizationFailure.apply(this, arguments);
      }

      return logCCTokenizationFailure;
    }()
  }, {
    key: "tokenizePayPal",
    value: function () {
      var _tokenizePayPal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(payerId, payLoadNonce, deviceData) {
        var channel,
            response,
            _args14 = arguments;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                channel = _args14.length > 3 && _args14[3] !== undefined ? _args14[3] : "desktop";
                _context14.next = 3;
                return this.axios.post(this.config.postfix.TOKENIZE_PAYPAL, {
                  payerId: payerId,
                  payLoadNonce: payLoadNonce,
                  deviceData: deviceData,
                  transactionType: "PAYPAL_TOGO",
                  channel: channel
                });

              case 3:
                response = _context14.sent;
                return _context14.abrupt("return", response.data);

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function tokenizePayPal(_x22, _x23, _x24) {
        return _tokenizePayPal.apply(this, arguments);
      }

      return tokenizePayPal;
    }()
  }, {
    key: "getGiftCardBalance",
    value: function () {
      var _getGiftCardBalance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(payload, jwtToken) {
        var headers;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                _context15.next = 4;
                return this.axios.post(this.config.postfix.CHECK_GC_BALANCE, payload, {
                  headers: headers
                }).then(function (response) {
                  var _response$data3;

                  return {
                    data: (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.response
                  };
                })["catch"](function (error) {
                  throw new UIError(error);
                });

              case 4:
                return _context15.abrupt("return", _context15.sent);

              case 5:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function getGiftCardBalance(_x25, _x26) {
        return _getGiftCardBalance.apply(this, arguments);
      }

      return getGiftCardBalance;
    }()
  }, {
    key: "deleteGiftCard",
    value: function () {
      var _deleteGiftCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(jwtToken, payload) {
        var _this3 = this;

        var commonQueryParams, locale, headers;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                _context16.next = 5;
                return this.axios.put(this.config.postfix.DELETE_GIFT_CARD, payload, {
                  headers: headers,
                  params: {
                    locale: locale
                  }
                }).then(function (response) {
                  return _this3.processGiftCardsAPIResponse(response);
                })["catch"](function (error) {
                  throw new UIError(error);
                });

              case 5:
                return _context16.abrupt("return", _context16.sent);

              case 6:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function deleteGiftCard(_x27, _x28) {
        return _deleteGiftCard.apply(this, arguments);
      }

      return deleteGiftCard;
    }()
  }, {
    key: "processGiftCardResponse",
    value: function processGiftCardResponse(giftCardDetails) {
      return giftCardDetails === null || giftCardDetails === void 0 ? void 0 : giftCardDetails.map(function (giftCard) {
        return _objectSpread(_objectSpread({}, giftCard), {}, {
          giftCardNumber: giftCard.giftCardNumber
        });
      });
    }
  }, {
    key: "processCreditCardResponse",
    value: function processCreditCardResponse(creditCardDetails) {
      return creditCardDetails === null || creditCardDetails === void 0 ? void 0 : creditCardDetails.map(function (creditCard) {
        var _creditCard$billingAd, _creditCard$billingAd2, _creditCard$billingAd3, _creditCard$billingAd4;

        return _objectSpread(_objectSpread({}, creditCard), {}, {
          nameOnCard: "".concat((_creditCard$billingAd = (_creditCard$billingAd2 = creditCard.billingAddress) === null || _creditCard$billingAd2 === void 0 ? void 0 : _creditCard$billingAd2.firstName) !== null && _creditCard$billingAd !== void 0 ? _creditCard$billingAd : "", " ", (_creditCard$billingAd3 = (_creditCard$billingAd4 = creditCard.billingAddress) === null || _creditCard$billingAd4 === void 0 ? void 0 : _creditCard$billingAd4.lastName) !== null && _creditCard$billingAd3 !== void 0 ? _creditCard$billingAd3 : "")
        });
      });
    }
  }, {
    key: "processPaymentMethodsAPIResponse",
    value: function processPaymentMethodsAPIResponse(response) {
      try {
        var _response$data4;

        var paymentMethodsResponse = response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.response;

        var paymentMethods = _objectSpread(_objectSpread({}, paymentMethodsResponse), {}, {
          creditCards: this.processCreditCardResponse(paymentMethodsResponse === null || paymentMethodsResponse === void 0 ? void 0 : paymentMethodsResponse.creditCards),
          giftCards: this.processGiftCardResponse(paymentMethodsResponse === null || paymentMethodsResponse === void 0 ? void 0 : paymentMethodsResponse.giftCards)
        });

        return paymentMethods;
      } catch (error) {
        throw new Error(error);
      }
    }
  }, {
    key: "getPaymentMethods",
    value: function () {
      var _getPaymentMethods = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(jwtToken) {
        var _this4 = this;

        var headers;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                _context17.next = 3;
                return this.axios.get(this.config.postfix.PAYMENT_METHODS, {
                  headers: headers
                }).then(function (response) {
                  return _this4.processPaymentMethodsAPIResponse(response);
                })["catch"](function (error) {
                  throw new UIError(error);
                });

              case 3:
                return _context17.abrupt("return", _context17.sent);

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function getPaymentMethods(_x29) {
        return _getPaymentMethods.apply(this, arguments);
      }

      return getPaymentMethods;
    }()
  }, {
    key: "processGiftCardsAPIResponse",
    value: function () {
      var _processGiftCardsAPIResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(response) {
        var _response$data5, giftCardsResponse, giftCards;

        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                giftCardsResponse = response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.response;
                giftCards = _objectSpread(_objectSpread({}, giftCardsResponse), {}, {
                  giftCards: this.processGiftCardResponse(giftCardsResponse === null || giftCardsResponse === void 0 ? void 0 : giftCardsResponse.giftCards)
                });
                return _context18.abrupt("return", giftCards);

              case 6:
                _context18.prev = 6;
                _context18.t0 = _context18["catch"](0);
                throw new Error(_context18.t0);

              case 9:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[0, 6]]);
      }));

      function processGiftCardsAPIResponse(_x30) {
        return _processGiftCardsAPIResponse.apply(this, arguments);
      }

      return processGiftCardsAPIResponse;
    }()
  }, {
    key: "getGiftCards",
    value: function () {
      var _getGiftCards = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(jwtToken) {
        var _this5 = this;

        var headers;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                _context19.next = 3;
                return this.axios.get(this.config.postfix.GET_GIFT_CARDS, {
                  headers: headers
                }).then(function (response) {
                  return _this5.processGiftCardsAPIResponse(response);
                })["catch"](function (error) {
                  throw new UIError(error);
                });

              case 3:
                return _context19.abrupt("return", _context19.sent);

              case 4:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function getGiftCards(_x31) {
        return _getGiftCards.apply(this, arguments);
      }

      return getGiftCards;
    }()
  }, {
    key: "processCreditCardsAPIResponse",
    value: function processCreditCardsAPIResponse(response) {
      try {
        var _response$data6;

        var creditCardsResponse = response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.response;
        return _objectSpread(_objectSpread({}, creditCardsResponse), {}, {
          creditCards: this.processCreditCardResponse(creditCardsResponse.creditCards)
        });
      } catch (error) {
        throw new Error(error);
      }
    }
  }, {
    key: "getCreditCards",
    value: function () {
      var _getCreditCards = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(jwtToken) {
        var _this6 = this;

        var headers;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                _context20.next = 3;
                return this.axios.get(this.config.postfix.GET_CREDIT_CARDS, {
                  headers: headers
                }).then(function (response) {
                  return _this6.processCreditCardsAPIResponse(response);
                })["catch"](function (error) {
                  throw new UIError(error);
                });

              case 3:
                return _context20.abrupt("return", _context20.sent);

              case 4:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function getCreditCards(_x32) {
        return _getCreditCards.apply(this, arguments);
      }

      return getCreditCards;
    }()
  }, {
    key: "saveCreditCard",
    value: function () {
      var _saveCreditCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(jwtToken, payload) {
        var _this7 = this;

        var headers;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                _context21.next = 3;
                return this.axios.post(this.config.postfix.ADD_CREDIT_CARD, payload, {
                  headers: headers
                }).then(function (response) {
                  return _this7.processCreditCardsAPIResponse(response);
                })["catch"](function (error) {
                  throw new UIError(error);
                });

              case 3:
                return _context21.abrupt("return", _context21.sent);

              case 4:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function saveCreditCard(_x33, _x34) {
        return _saveCreditCard.apply(this, arguments);
      }

      return saveCreditCard;
    }()
  }, {
    key: "saveGiftCard",
    value: function () {
      var _saveGiftCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(jwtToken, payload) {
        var _this8 = this;

        var headers;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                _context22.next = 3;
                return this.axios.post(this.config.postfix.SAVE_GIFT_CARD, payload, {
                  headers: headers
                }).then(function (response) {
                  return _this8.processGiftCardsAPIResponse(response);
                })["catch"](function (error) {
                  throw new UIError(error);
                });

              case 3:
                return _context22.abrupt("return", _context22.sent);

              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function saveGiftCard(_x35, _x36) {
        return _saveGiftCard.apply(this, arguments);
      }

      return saveGiftCard;
    }()
  }, {
    key: "deleteCreditCard",
    value: function () {
      var _deleteCreditCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(jwtToken, payload) {
        var _this9 = this;

        var headers;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                _context23.next = 3;
                return this.axios.put(this.config.postfix.DELETE_CREDIT_CARD, payload, {
                  headers: headers
                }).then(function (response) {
                  return _this9.processCreditCardsAPIResponse(response);
                })["catch"](function (error) {
                  throw new UIError(error);
                });

              case 3:
                return _context23.abrupt("return", _context23.sent);

              case 4:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function deleteCreditCard(_x37, _x38) {
        return _deleteCreditCard.apply(this, arguments);
      }

      return deleteCreditCard;
    }()
  }]);

  return Payment;
}();

export { Payment as default };